import NBType, { InferType } from '@netbase/nb-type'
import DetectType from '../enums/DetectType'

/**
 * @typedef {import('../enums/DetectType').DetectType} DetectType
 */

/**
 * @typedef {object} PhotoConceptServicePropertySchema
 * @property {DetectType} detectType
 */
const PhotoConceptServicePropertySchema = NBType.object().shape(
  'PhotoConceptServicePropertySchema',
  {
    /* @prop */
    detectType: NBType.enum(DetectType)
    /* END */
  }
)
export default PhotoConceptServicePropertySchema
export type PhotoConceptServiceProperty = InferType<typeof PhotoConceptServicePropertySchema>
// RESERVE BELOW
